import NameCode from './name-code';

export default NameCode;
